// extracted by mini-css-extract-plugin
module.exports = {"mvpCard":"mvp-card_mvpCard__OJ61K"};